// extracted by mini-css-extract-plugin
export default {"preloader":"viewFile_preloader__bvFXH","spinner":"viewFile_spinner__-wEWK"};